export enum Step {
  VIEW_VISIT_LIST = 'view-visit_list',
  VIEW_ORDER_DELIVERY_TYPE = 'view-order-delivery-type',
  VIEW_PRODUCTS_LIST = 'view-products_list',
  VIEW_OPTION_LIST = 'view-option-list',
  VIEW_DOSE_DURATION = 'view-dose-duration',
  VIEW_CART = 'view-cart',
  VIEW_PAYMENT_ORDER = 'view-payment-order',
  VIEW_COMPLETE_ORDER = 'view-complete-order',
  VIEW_MOUD_DELIVERY_COMBINED_PRODUCTS = 'view-delivery-combined-products',
  VIEW_HOME_ORDER_DELIVERY_TYPE = 'view-home-order-delivery-type',
}

export type OrderCategory = 'moud' | 'MenopauseHormoneTherapy'
export enum OrderCategories {
  moud = 'moud',
  mht = 'MenopauseHormoneTherapy',
}

// Visit ServiceTypeCategory values. The backend returns these as a free-form
// string (the generated OpenAPI type is `string`), so this local enum gives us
// a typed, single source of truth instead of scattering string literals.
export enum ServiceTypeCategory {
  MedicationAssistedTreatment = 'medicationassistedtreatment',
  MenopauseHormoneTherapy = 'MenopauseHormoneTherapy',
}

export const MOUD_DELIVERY_COHORTS = ['DeliverySuboxoneHoneybee', 'DeliverySuboxonePharmacyHub']
export type PharmacyPartnerType = 'thrive' | 'standard'
export const PharmacyPartners = {
  thrive: { name: 'Thrive', title: 'Troches', type: 'thrive' },
  honeybee: { name: 'Honeybee', title: 'Strips or tablets', type: 'standard' },
  pharmacyHub: { name: 'PharmacyHub', title: 'Strips or tablets', type: 'standard' },
  getPharmacyPartnerTitle: (type: string | undefined) => {
    if (type === PharmacyPartners.thrive.type) return PharmacyPartners.thrive.title
    if (type === PharmacyPartners.honeybee.type) return PharmacyPartners.honeybee.title
    if (type === PharmacyPartners.pharmacyHub.type) return PharmacyPartners.pharmacyHub.title
  },
} as const
